import * as d3 from 'd3'
export default {
  methods: {

    ani_Image_ON() {
      this.ani_Image_OFF()
      this.toggle = 'ON'

      this.animationInterval = setInterval(() => {
        if (this.toggle !== 'ON') {
          this.ani_Image_OFF()
          return
        }

        let old = this.current.idx
        this.current.idx + 1 > this.rawData.length ? this.current.idx = 1 : ++this.current.idx
        let d = this.rawData.find(f => f.SN === this.current.idx)
        if (!d) {
          console.error("Animation data not found for index:", this.current.idx)
          this.ani_Image_OFF()
          return
        }

        this.current.blk = d.ER_BK
        d3.selectAll(`.ROWS`).attr('fill', '#757575')
        d3.selectAll(`.ROW_${d.SN}_${this.localId}`).attr('fill', '#44A9DF')

        this.reload_SVG(d, old)
      }, 2000)
    },

    ani_Image_OFF() {
      this.toggle = 'OFF'
      if (this.animationInterval) {
        clearInterval(this.animationInterval)
        this.animationInterval = null
      }
    },


  }
}